import moment from 'moment'

const ptBrFormatDateWithAddDays = ({ date, numberAdd, dateFormatAdd }) => {
  return moment(date).add(numberAdd, dateFormatAdd).format('DD/MM/YYYY')
}

const ptBrFormatDate = (date, response) => {
  return date ? moment(date).format('DD/MM/YYYY') : response ?? '-'
}

const ptBrFormatHours = (date, response) => {
  return date ? moment(date).format('HH:mm') : response ?? '-'
}

const ptBrFormatDateTime = (date, response) => {
  return date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : response ?? '-'
}

export default {
  ptBrFormatDate,
  ptBrFormatDateWithAddDays,
  ptBrFormatHours,
  ptBrFormatDateTime,
}
